const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/donate-key.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/donate-key")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});